import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useModal } from 'providers/ModalProvider'
import { OpenTicketModal } from 'components/modals/OpenTicketModal'
import { useDispatch, useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { settingsActions, settingsSelectors } from 'store/settings'
import { OdinButton } from '@/components/ui/odin/odin-button'
import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { Marker, MarkerContent, MarkerIcon } from '@/components/ui/marker'
import { useIsAuthModeNoLogin } from 'hooks/useAuthMode'
import { analytics, ANALYTICS_EVENTS } from 'services/analytics'

export const TicketReminderRow = () => {
  const { t } = useTranslation()
  const { openModal } = useModal()
  const ticketReminderVisible = useSelector(settingsSelectors.ticketReminderVisible)
  const dispatch = useDispatch()
  const isInOperatorMode = useSelector(messagesSelectors.currentChatIsInOperatorMode)
  const isNoLogin = useIsAuthModeNoLogin()

  const onClickDismissHelp = useCallback(() => {
    analytics.track(ANALYTICS_EVENTS.TICKET_REMINDER_DISMISSED)
    dispatch(settingsActions.setTicketReminderVisible(false))
  }, [dispatch])

  const onClickOpenTicket = useCallback(() => {
    analytics.track(ANALYTICS_EVENTS.TICKET_MODAL_OPEN)
    openModal(<OpenTicketModal />)
  }, [openModal])

  if (!(ticketReminderVisible && !isInOperatorMode && !isNoLogin)) return null

  return (
    <Marker variant="separator" role="status" className="animate-in duration-300 fade-in">
      <MarkerIcon className="text-primary">
        <OdinIcon icon={['fas', 'headset']} />
      </MarkerIcon>
      <MarkerContent>{t('needOperatorShort')}</MarkerContent>
      <div className="flex shrink-0 gap-1">
        <OdinButton size="sm" className="rounded-full text-xs" onClick={onClickOpenTicket}>
          {t('yes')}
        </OdinButton>
        <OdinButton size="sm" variant="ghost" className="rounded-full text-xs" onClick={onClickDismissHelp}>
          {t('no')}
        </OdinButton>
      </div>
    </Marker>
  )
}
